
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.492 28.281H6.667a3.857 3.857 0 01-3.852-3.852V5.571a3.857 3.857 0 013.852-3.852h7.952c.478 0 .86-.382.86-.86a.856.856 0 00-.86-.859H6.667a5.577 5.577 0 00-5.57 5.57v18.86A5.577 5.577 0 006.666 30h7.825a.86.86 0 000-1.719z","fill":"#979797"}}),_c('path',{attrs:{"d":"M28.651 14.395L23.19 8.933a.857.857 0 00-1.216 0 .857.857 0 000 1.216l3.998 3.998H8.532a.856.856 0 00-.86.86c0 .477.383.859.86.859h17.439l-3.998 3.998a.857.857 0 000 1.216.865.865 0 00.604.255c.217 0 .44-.083.605-.255l5.463-5.462a.859.859 0 00.006-1.223z","fill":"#979797"}})])
          )
        }
      }
    